// Centralized query keys — dễ invalidate theo nhóm
export const qk = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  settings: {
    get: ['settings'] as const,
  },
  categories: {
    list: ['categories'] as const,
    one:  (slug: string) => ['categories', slug] as const,
  },
  products: {
    list:    (filter: unknown) => ['products', 'list', filter] as const,
    one:     (slug: string)    => ['products', 'one', slug] as const,
    brands:  ['products', 'brands'] as const,
  },
  cart: {
    me: ['cart', 'me'] as const,
  },
  orders: {
    mine: (q: unknown) => ['orders', 'mine', q] as const,
    all:  (q: unknown) => ['orders', 'all', q] as const,
    one:  (id: string) => ['orders', 'one', id] as const,
  },
  promo: {
    campaigns:  (all?: boolean) => ['promo', 'campaigns', { all: !!all }] as const,
    flashDeals: (all?: boolean) => ['promo', 'deals', { all: !!all }] as const,
  },
  articles: {
    list:       (q: unknown)  => ['articles', 'list', q] as const,
    one:        (slug: string) => ['articles', 'one', slug] as const,
    categories: ['articles', 'categories'] as const,
    adminAll:   (q: unknown)  => ['articles', 'admin', q] as const,
  },
  users: {
    list: (q: unknown) => ['users', 'list', q] as const,
    one:  (id: string) => ['users', 'one', id] as const,
  },
}
